import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc9b5cf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modalElement",
  class: "overflow-auto"
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "activity-container" }
const _hoisted_4 = { class: "activity-title font-bold" }
const _hoisted_5 = { class: "activity-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, "活動時間", -1))
const _hoisted_7 = { class: "activity-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, "活動內容", -1))
const _hoisted_9 = { class: "text-left text-xs leading-[17px] list-disc pl-4 list-none pl-0 content-list" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "activity-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, "注意事項", -1))
const _hoisted_13 = { class: "text-left text-xs leading-[17px] list-disc pl-4 list-none pl-0 warningDesc-list" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "flex gap-3 mt-[30px] justify-center" }
const _hoisted_16 = { class: "mb-[30px]" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Title = _resolveComponent("Title")!
  const _component_ProductItemListActivity = _resolveComponent("ProductItemListActivity")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    show: _ctx.show,
    class: "modal-500-width",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:show', false)))
  }, {
    body: _withCtx(() => [
      _createVNode(_component_Icon, {
        iconName: "modal-close",
        class: "absolute top-4 right-4 cursor-pointer z-[99999]",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:show', false)))
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "activity-image",
            style: _normalizeStyle({ backgroundImage: `url('${_ctx.isMobile().any ? _ctx.activityData.CoverImage.MobileWeb : _ctx.activityData.CoverImage.PcWeb}')` })
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.activityData.Name), 1),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", null, _toDisplayString(`${_ctx.activityData.EffectiveDateStart} - ${_ctx.activityData.EffectiveDateEnd}`), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("ul", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.Content, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  innerHTML: item
                }, null, 8, _hoisted_10))
              }), 128))
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("ul", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityData.WarningDesc, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  innerHTML: item
                }, null, 8, _hoisted_14))
              }), 128))
            ])
          ], 512), [
            [_vShow, _ctx.activityData.WarningDesc?.length > 0]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_Btn, {
              text: '更多活動',
              widt: '169px',
              type: 'light',
              fontSize: '14px',
              required: true,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openActivityListModal')))
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_Btn, {
              text: '回商品頁',
              widt: '169px',
              fontSize: '14px',
              onClick: _ctx.cancel
            }, null, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_Title, {
            class: "mt-[10px]",
            title: '活動商品',
            subTitle: ''
          }),
          _hoisted_19
        ]),
        _createVNode(_component_ProductItemListActivity, {
          isGoProductDetail: true,
          class: "mt-[36px] sm:mt-[30px]",
          row: 2,
          cmdyList: _ctx.activityData.CommodityList
        }, null, 8, ["cmdyList"])
      ], 512)
    ]),
    _: 1
  }, 8, ["show"]))
}